import React from "react";

const Loading = () => (
  <div>
    {/* Contenido eliminado */}
  </div>
);

export default Loading;
